// @flow
import React, {type Node, PureComponent} from 'react';
import withLingua from '../withLingua/withLingua';
import HeaderBar from '../Header/HeaderBar';

import type {LinguaProps} from '../withLingua/withLingua';

type OwnProps = {
    internalTools?: Node,
    showBrandTransitionBanner: string,
    messages: Object
};

type Props = OwnProps & LinguaProps;

export class ConnectedHeader extends PureComponent<Props> {
    render() {
        const {messages, internalTools, showBrandTransitionBanner} = this.props;

        const lingua = {
            tabText: messages['shared.stabFeedback.tabText'],
            title: messages['shared.stabFeedback.title'],
            reviewLink: messages['shared.stabFeedback.reviewLink'],
            reviewLinkText:
                messages['shared.stabFeedback.lookingToWriteReview'],
            helpLink: messages['shared.stabFeedback.helpLink'],
            helpLinkText: messages['shared.stabFeedback.lookingForSupport'],
            supportLinkText: messages['shared.stabFeedback.leaveComment'],
            externalLinkSrText:
                messages['shared.stabFeedback.externalLinkSrText']
        };
        return (
            <HeaderBar
                internalTools={internalTools}
                showBrandTransitionBanner={showBrandTransitionBanner}
                feedbackComponentLingua={lingua}
            />
        );
    }
}

export default withLingua({
    namespace: 'ui-development/shared',
    category: 'stabFeedback'
})(ConnectedHeader);
